import React, { useState } from "react";
import { SpeakerDistributionDiagram, SpeakerDistributionItem } from "./SpeakerDistributionDiagram";
import { useUi } from "@jelly/lesson";

import { messages } from "../technicalDetails.messages";
import { useIntl, MessageDescriptor } from "react-intl";
import { PhotoView } from "@src/lms/jelly/extensions/layouts/photo-view/PhotoView";
import * as appConfig from "appConfig";

import styles from "./SpeakerDistributionSlide.module.scss";

interface ModalData {
  title: MessageDescriptor;
  description: MessageDescriptor;
  imgDescription: MessageDescriptor;
  imgSrc: string;
}

const MODAL_DATA: Record<SpeakerDistributionItem, ModalData> = {
  "label-main-system": {
    title: messages.mainSystemTitle,
    description: messages.mainSystemDescription,
    imgDescription: messages.mainSystemImageDescription,
    imgSrc: `${appConfig.STATIC_ASSETS_URL}/lms/case/case05/technical-details/main-system.jpg`,
  },
  "label-lfe": {
    title: messages.LFETitle,
    description: messages.LFEDescription,
    imgDescription: messages.LFEImageDescription,
    imgSrc: `${appConfig.STATIC_ASSETS_URL}/lms/case/case05/technical-details/lfe.jpg`,
  },
  "label-celling-system": {
    title: messages.CeilingSystemTitle,
    description: messages.CeilingSystemDescription,
    imgDescription: messages.CeilingSystemImageDescription,
    imgSrc: `${appConfig.STATIC_ASSETS_URL}/lms/case/case05/technical-details/ceiling-system.jpg`,
  },
  "label-front-fills": {
    title: messages.FrontFillsTitle,
    description: messages.FrontFillsDescription,
    imgDescription: messages.FrontFillsImageDescription,
    imgSrc: `${appConfig.STATIC_ASSETS_URL}/lms/case/case05/technical-details/front-fills.png`,
  },
} as const;

export const SpeakerDistributionSlide: React.FC = () => {
  const [activeItem, setActiveItem] = useState<SpeakerDistributionItem | null>(null);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const { formatMessage } = useIntl();
  const closePopup = (): void => setModalOpen((open) => !open);
  const ui = useUi();
  const handleItemClick = (item: SpeakerDistributionItem): void => {
    setActiveItem(item);
    setModalOpen(true);
  };

  const activeItemData = MODAL_DATA[activeItem ?? "label-main-system"];
  return (
    <>
      <SpeakerDistributionDiagram
        onItemSelect={handleItemClick}
        activeItems={modalOpen && activeItem ? [activeItem] : []}
      />
      <ui.Modal
        visible={modalOpen}
        onClose={closePopup}
        title={formatMessage(activeItemData.title)}
        className={styles.modal}
      >
        <div className={styles.content}>
          <p>{formatMessage(activeItemData.description)}</p>
          <PhotoView imgSrc={activeItemData.imgSrc} description={formatMessage(activeItemData.imgDescription)} />
        </div>
      </ui.Modal>
    </>
  );
};
